$(document).ready(function(){
     function AddReadMore() {
      //This limit you can set after how much characters you want to show Read More.
      var carLmt = 300;
      if (screen.width < 749) {
          var carLmt = 90;
      }
      // Text to show when text is collapsed
      var readMoreTxt = " ...mehr lesen";
      // Text to show when text is expanded
      var readLessTxt = " Weniger anzeigen";


      //Traverse all selectors with this class and manupulate HTML part to show Read More
      $(".add-read-more").each(function () {
         if ($(this).find(".first-section").length)
            return;

         var allstr = $(this).text();
         if (allstr.length > carLmt) {
            var firstSet = allstr.substring(0, carLmt);
            var secdHalf = allstr.substring(carLmt, allstr.length);
            var strtoadd = firstSet + "<span class='second-section'>" + secdHalf + "</span><span class='read-more'  title='Click to Show More'>" + readMoreTxt + "</span><span class='read-less' title='Click to Show Less'>" + readLessTxt + "</span>";
            $(this).html(strtoadd);
         }
      });

      //Read More and Read Less Click Event binding
      $(document).on("click", ".read-more,.read-less", function () {
         $(this).closest(".add-read-more").toggleClass("show-less-content show-more-content");
      });
   }

   AddReadMore();
});

//Ak custom code
document.addEventListener('DOMContentLoaded', function () {

var isALARendered;
function ALAcheck() {
  isALARendered = setInterval(function () {
    customALA();
  }, 200);
}
ALAcheck();

function customALA() {
  var selector = document.querySelector('.klaviyo-bis-trigger');
  var target = document.querySelector('.product-form__buttons-row');

  if (selector && target) {
    // Insert the selector after the target
    target.insertAdjacentElement('afterend', selector);
    clearInterval(isALARendered); // Stop checking once the operation is complete
  }
}


  
  function activateCollection(current_tab) {
    // Destroy any existing Swiper instances
    const initializedSwipers = document.querySelectorAll('.favorites-colleciton-list .swiper-container.swiper-initialized');
    initializedSwipers.forEach(container => {
      container.swiper.destroy(true, true); // Destroy existing Swiper instance
    });

    // Remove active class from all tabs and hide all collections
    document.querySelectorAll('.nav-favorites-list li').forEach(tab => {
      tab.classList.remove('active');
    });
    document.querySelectorAll('.collection-inner-list').forEach(collection => {
      collection.classList.remove('active');
      collection.style.display = 'none';
    });

    // Add active class to the matching tab and show the corresponding collection
    const activeTab = document.querySelector(`.nav-favorites-list li.${current_tab}`);
    const activeCollection = document.querySelector(`.collection-inner-list.${current_tab}`);
    if (activeTab) activeTab.classList.add('active');
    if (activeCollection) {
      activeCollection.classList.add('active');
      activeCollection.style.display = 'block';

      // Initialize Swiper for the active collection
      new Swiper(`.collection-inner-list.${current_tab}`, {
        loop: false,
        navigation: {
          nextEl: '.arrow-wrap .swiper-button-next',
          prevEl: '.arrow-wrap .swiper-button-prev',
        },
        slidesPerView: 2,
        paginationClickable: true,
        spaceBetween: 22,
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          576: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          749: {
            slidesPerView: 3,
            spaceBetween: 22,
          },
          1199: {
            slidesPerView: 4,
            spaceBetween: 22,
          },
        },
      });
    }
  }

  // Handle tab clicks
  document.querySelectorAll('.nav-favorites-list li').forEach(tab => {
    tab.addEventListener('click', function () {
      const current_tab = this.getAttribute('current-tab');
      activateCollection(current_tab);
    });
  });

  // Handle dropdown selection change
  const dropdown = document.querySelector('select');
  if (dropdown) {
    dropdown.addEventListener('change', function () {
      const current_tab = this.options[this.selectedIndex].getAttribute('current-tab');
      activateCollection(current_tab);
    });
  }

  // Initialize Swiper for the default active collection on page load
  const defaultTab = document.querySelector('.nav-favorites-list li.active');
  if (defaultTab) {
    const defaultTabAttr = defaultTab.getAttribute('current-tab');
    activateCollection(defaultTabAttr);
  }
});






// if ($(window).width() < 1199) {
//     let main_pro_slider_height = $(".product__media-list").height();
//     $( "#container" ).css( { "height" : main_pro_slider_height,"max-height" : main_pro_slider_height } );
// }


	// document.querySelector('.announcement-bar__text').addEventListener('click', function (){
 //      console.log('hii click klaviyp')
	// 	window._klOnsite = window._klOnsite || []; 
	// 	window._klOnsite.push(['openForm', 'WvF2q2']);
	// });


